import { render } from "./ImportStudy.vue?vue&type=template&id=a925091c&scoped=true"
import script from "./ImportStudy.js?vue&type=script&lang=js"
export * from "./ImportStudy.js?vue&type=script&lang=js"

import "./ImportStudy.vue?vue&type=style&index=0&id=a925091c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a925091c"]])

export default __exports__